export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_DEPARTMENTS: 'SET_DEPARTMENTS',
    SET_SELECTED_DEPARTMENT: 'SET_SELECTED_DEPARTMENT',
    ADD_DEPARTMENT: 'ADD_DEPARTMENT',
    UPDATE_DEPARTMENT: 'UPDATE_DEPARTMENT',
    DELETE_DEPARTMENT: 'DELETE_DEPARTMENT',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    departments: [],
    selectedDepartment: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const departmentReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_DEPARTMENTS:
            return {
                ...state,
                departments: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_DEPARTMENT:
            return {
                ...state,
                selectedDepartment: action.payload,
                loading: false
            };

        case ACTIONS.ADD_DEPARTMENT:
            return {
                ...state,
                departments: [action.payload, ...state.departments],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_DEPARTMENT:
            return {
                ...state,
                departments: state.departments.map((department) =>
                    department.id === action.payload.id ? action.payload.data : department
                ),
                selectedDepartment: state.selectedDepartment?.id === action.payload.id ? action.payload.data : state.selectedDepartment,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_DEPARTMENT:
            return {
                ...state,
                departments: state.departments.filter((department) => department.id !== action.payload),
                selectedDepartment: state.selectedDepartment?.id === action.payload ? null : state.selectedDepartment,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
